/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CourseModule } from './courseModule';

export interface Course {
  active?: boolean;
  author?: string;
  businessUnitId?: number;
  courseId?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  description?: string;
  image?: string;
  link?: string;
  modules?: Array<CourseModule>;
  name?: string;
  subtitle?: string;
}
